import { graphql, useStaticQuery } from 'gatsby'
import { getDataByLocale } from '~/hooks/utils/get-data-by-locale'

const useNavigationQuery = locale => {
  const data = useStaticQuery(graphql`
    {
      contentfulNavigationBar_enUS: contentfulNavigationBar(
        slug: { eq: "navigation-bar" }
        node_locale: { eq: "en-US" }
      ) {
        tabs {
          __typename
          ...NavSectionFragment
          ... on ContentfulPage {
            id
            name
            slug
          }
          ... on ContentfulCollection {
            id
            name
            slug
            images {
              title
              gatsbyImageData(quality: 90)
            }
            products {
              ...ProductLinkFragment
            }
          }
        }
      }

      contentfulNavigationBar_enCA: contentfulNavigationBar(
        slug: { eq: "navigation-bar" }
        node_locale: { eq: "en-CA" }
      ) {
        tabs {
          __typename
          ...NavSectionFragment
          ... on ContentfulPage {
            id
            name
            slug
          }
          ... on ContentfulCollection {
            id
            name
            slug
            images {
              title
              gatsbyImageData(quality: 90)
            }
            products {
              ...ProductLinkFragment
            }
          }
        }
      }

      contentfulNavigationBar_frCA: contentfulNavigationBar(
        slug: { eq: "navigation-bar" }
        node_locale: { eq: "fr-CA" }
      ) {
        tabs {
          __typename
          ...NavSectionFragment
          ... on ContentfulPage {
            id
            name
            slug
          }
          ... on ContentfulCollection {
            id
            name
            slug
            images {
              title
              gatsbyImageData(quality: 90)
            }
            products {
              ...ProductLinkFragment
            }
          }
        }
      }

      contentfulNavigationBar_heIL: contentfulNavigationBar(
        slug: { eq: "navigation-bar" }
        node_locale: { eq: "he-IL" }
      ) {
        tabs {
          __typename
          ...NavSectionFragment
          ... on ContentfulPage {
            id
            name
            slug
          }
          ... on ContentfulCollection {
            id
            name
            slug
            images {
              title
              gatsbyImageData(quality: 90)
            }
            products {
              ...ProductLinkFragment
            }
          }
        }
      }

      contentfulNavigationBar_esMX: contentfulNavigationBar(
        slug: { eq: "navigation-bar" }
        node_locale: { eq: "es-MX" }
      ) {
        tabs {
          __typename
          ...NavSectionFragment
          ... on ContentfulPage {
            id
            name
            slug
          }
          ... on ContentfulCollection {
            id
            name
            slug
          }
        }
      }
    }
  `)
  return getDataByLocale(locale, data, 'contentfulNavigationBar_')
}

export default useNavigationQuery
